module.exports = __webpack_public_path__ + "static/media/backgroundVid.5a89db9.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backgroundVid.mp4
// module id = I7T4
// module chunks = 1